"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useWindowInactivity = (delay = 5) => {
    const [inactive, setInactive] = (0, react_1.useState)(false);
    const millisenconds = delay * 1000;
    const events = ["mousemove", "touchstart"];
    (0, react_1.useEffect)(() => {
        let timeout;
        events.forEach((event) => window.addEventListener(event, () => {
            clearTimeout(timeout);
            setInactive(false);
            timeout = setTimeout(() => {
                setInactive(true);
            }, millisenconds);
        }));
        return () => events.forEach((event) => window.removeEventListener(event, () => {
            clearTimeout(timeout);
            setInactive(false);
            timeout = setTimeout(() => {
                setInactive(true);
            }, millisenconds);
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return inactive;
};
exports.default = useWindowInactivity;
